var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeaserBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 173,
    viewBox: "0 0 200 173",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.498 0c23.114 0 67.8 4.5 84.276 22.775 16.12 17.88 6.677 112.215-12.17 130.569C162.142 170.316 140.767 173 107.499 173c-32.833 0-72.62-1.54-92.731-23.8C-3.763 128.673-3.526 35.325 8.129 21.905 26.265 1.026 79.643 0 107.498 0z",
    fill: "#E6F2F8",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeaserBackground);
export default __webpack_public_path__ + "static/media/teaser-background.d7255977196b70d09b84556bb4403930.svg";
export { ForwardRef as ReactComponent };